// extracted by mini-css-extract-plugin
export default {"StickyHeader":"HeatList_StickyHeader__hZnqC","RecBubble":"HeatList_RecBubble__RfVDk"};